export default __webpack_public_path__ + "static/media/Megaphone.4b299235.png";